"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.sumArrayTill = sumArrayTill, exports.calculateSegmentStops = calculateSegmentStops, exports.calculateNeedleHeight = calculateNeedleHeight, exports.calculateSegmentLabelCount = calculateSegmentLabelCount, exports.calculateScale = calculateScale, exports.calculateTicks = calculateTicks, exports.formatCurrentValueText = formatCurrentValueText, exports.deg2rad = deg2rad, exports.centerTranslation = centerTranslation, exports.getRadius = getRadius;

var _lodash = require("lodash"),
    _fp = require("lodash/fp"),
    _d = require("d3");

function sumArrayTill(a, b) {
  return (0, _lodash.sum)((0, _fp.take)(b)(a));
}

function calculateSegmentStops(a) {
  var b = a.tickData,
      c = a.customSegmentStops,
      d = a.min,
      e = a.max;
  if (!(0, _lodash.isArray)(c) || (0, _lodash.isEmpty)(c)) return b;
  if ((0, _lodash.head)(c) !== d) throw new Error("First value should be equivalent to min value given. Current min value - ".concat(d));
  if ((0, _lodash.last)(c) !== e) throw new Error("Last value should be equivalent to max value given. Current min value - ".concat(e));
  var f = c.map(function (a, b) {
    return 0 === b ? void 0 : (a - c[b - 1]) / (e - d);
  });
  return (0, _lodash.drop)(f);
}

function calculateNeedleHeight(a) {
  var b = a.heightRatio,
      c = a.radius;
  if (0 > b || 1 < b) throw new Error("Invalid needleHeightRatio given - ".concat(b));
  return Math.round(c * b);
}

function calculateSegmentLabelCount(a) {
  var b = a.maxSegmentLabelCount,
      c = a.segmentCount,
      d = parseInt(b, 10),
      e = parseInt(c, 10);
  return (0, _lodash.isNumber)(d) && 0 <= d && d <= e ? d : e;
}

function calculateScale(a) {
  var b = a.min,
      c = a.max,
      d = a.segments;
  return (0, _d.scaleLinear)().range([0, 1]).domain([b, c]);
}

function calculateTicks(a, b) {
  var c = b.min,
      d = b.max,
      e = b.segments,
      f = [];
  f = a.ticks(e);
  var g = ((0, _lodash.last)(f) !== d || e < f.length) && 1 < f.length;

  if (g) {
    f = [c], (0, _lodash.times)(e, function (a) {
      f.push(c + (a + 1) * ((d - c) / e));
    });
  }

  return 1 === f.length && (f = [c, d]), f;
}

function formatCurrentValueText(a, b) {
  var c = b.labelFormat(a),
      d = b.currentValuePlaceholderStyle;
  return b.currentValueText.replace(d, c);
}

function deg2rad(a) {
  return a * Math.PI / 180;
}

function centerTranslation(a) {
  return "translate(".concat(a, ", ").concat(a, ")");
}

function getRadius(a) {
  return a.width / 2;
}